import { Fragment } from 'react';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import PlatformAdvancesPage from './PlatformAdvancesPage';

const PlatformAdvancesWrapper = () => {
    return (
        <Fragment>
            <PageHeader
                title="Avances plataforma"
                breadcrumb={[
                    { name: 'Ventas' },
                    { name: 'Gestión de campañas' },
                    { name: 'Avances plataforma', href: menuRoutes.calls.path + menuRoutes.calls.platformAdvances },
                ]}
            />
            <PlatformAdvancesPage />
        </Fragment>
    );
};

export default PlatformAdvancesWrapper;
